import {ReactComponent} from "./time-fill.svg";
import styled from "styled-components";

interface TimeFillIconProps {
    color?: string;
    size?: number;
}

const StyledIcon = styled(ReactComponent)<TimeFillIconProps>`
  width: ${({size}) => size}px;
  height: ${({size}) => size}px;

  path {
    fill: ${({color}) => color};
  }
`;

const TimeFillIcon: React.FC<TimeFillIconProps> = (
    {
        color = '#09121F',
        size = 24,
    }) => <StyledIcon color={color} size={size}/>;

export default TimeFillIcon;
